"use client";

import dynamic from "next/dynamic";
import { SectionHeading } from "@/components/ui/SectionHeading";
import type { RouteMapData } from "@/lib/dto";

const RouteMap = dynamic(
  () =>
    import("@/components/trip/RouteMap").then((m) => ({ default: m.RouteMap })),
  {
    ssr: false,
    loading: () => (
      <div className="h-[600px] flex items-center justify-center text-muted">
        Loading map…
      </div>
    ),
  },
);

type Props = {
  routeMap?: RouteMapData | null;
  title: string;
};

/**
 * Route map section with interactive Leaflet map.
 * Falls back to static image if route data is unavailable.
 */
export function RouteMapSection({ routeMap, title }: Props) {
  const hasValidRoute =
    routeMap?.route &&
    routeMap.route.length > 0 &&
    routeMap.route.some((day) => day.stops.length > 0);

  if (!hasValidRoute) return null;

  return (
    <section id="map" className="scroll-mt-32 mb-8">
      <SectionHeading title={title} />
      <div className="mt-5 rounded-md overflow-hidden border border-line">
        <RouteMap route={routeMap.route} />
      </div>
    </section>
  );
}
